<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
                <el-breadcrumb-item>分成比例设置</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>分成比例设置</h2>
                <div class="item" @click="toBack"><i class="icon el-icon-caret-left" type="primary"></i>返回设置</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="form-box p20 bg_fff">
                <div class="item d_flex">
                    <div class="name">平台返利比例:</div>
                    <div class="val">{{cashData.platform}}</div>
                </div>
                <div class="item d_flex">
                    <div class="name">城市代理返利比例:</div>
                    <div class="val">{{cashData.city_first}}</div>
                </div>
                <div class="item d_flex">
                    <div class="name">类型代理返利比例:</div>
                    <div class="val">{{cashData.city_second}}</div>
                </div>
                <div class="item d_flex">
                    <div class="name">直接推荐返利比例:</div>
                    <div class="val">{{cashData.referrer}}</div>
                </div>
                <div class="item d_flex">
                    <div class="name">用户收益比例:</div>
                    <div class="val">{{cashData.author}}</div>
                </div>
                <el-button class="btn" type="primary" @click="dialogVisible=true">修改</el-button>
            </div>
        </div>
        <el-dialog
                title="修改分成比例"
                :visible.sync="dialogVisible"
                width="500px"
                >
            <div class="box">
                <el-form ref="form" :model="form" label-width="150px">
                    <el-form-item label="平台返利比例">
                        <el-input v-model="form.platform" placeholder="请输入平台分成"></el-input>
                    </el-form-item>
                    <el-form-item label="城市代理返利比例">
                        <el-input v-model="form.city_first" placeholder="请输入城市代理分成"></el-input>
                    </el-form-item>
                    <el-form-item label="类型代理返利比例">
                        <el-input v-model="form.city_second" placeholder="请输入类型代理分成"></el-input>
                    </el-form-item>
                    <el-form-item label="直接推荐返利比例">
                        <el-input v-model="form.referrer" placeholder="请输入推荐人分成"></el-input>
                    </el-form-item>
                    <el-form-item label="用户收益比例">
                        <el-input v-model="form.author" placeholder="请输入会员分成"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="update">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import {cashsetting,cashInfo } from '../../api/withdraw'
    export default {
        name: "setting",
        data(){
            return{
                dialogVisible:false,
                cashData:'',
                form:{
                    platform:0,
                    city_first:0,
                    city_second:0,
                    referrer:0,
                    author:0
                }
            }
        },
        mounted(){
            this.getCash();
        },
        methods:{
            toBack(){
                this.$router.push({path:'/setting/setting'})
            },
            getCash(){
                cashInfo().then(res=>{
                    if(res.code==1){
                        this.cashData=res.data;
                        for(let i in res.data){
                            this.form[i]=res.data[i]
                        }
                    }
                })
            },
            update(){
                let num=0;
                for(let i in this.form){
                    num+=this.form[i]
                }
               if(num>100){
                   this.$message.error('总分成数不能大于100')
                   return;
               }
                cashsetting(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('修改成功');
                        this.dialogVisible=false;
                        this.getCash();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.form-box{
    text-align: left;
    .item{
        padding: 20px 0;
        .name{
            color: #666666;
            font-size: 15px;
            width: 150px;
            text-align: right;
            margin-right: 10px;
        }
        .val{
            width: 200px;
            border-bottom: 1px solid #eaeaea;
            padding: 0 10px;
        }
    }
    .btn{
        margin-top: 30px;
        margin-left: 50px;
    }
}
</style>
